var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.$prismic.linkResolver(_vm.link)}},[_vm._v("\n    "+_vm._s(_vm.linkText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }